import React from 'react';
import { ProgressionForm } from '../../components/Progression'
import { InteractiveWrapper } from '../../components/Interface'
import { Progression as ProgressionTemplate } from '../../components/Templates'

export const Progression = () => {
    return (
      <InteractiveWrapper 
        name="progression"
        title="Progression"
        template={ProgressionTemplate}
        initFunction="initProgression"
        hasStyles={true}
        topPadding={true}
      >
        <ProgressionForm />
      </InteractiveWrapper>
    )
}
